const millisecondsPerDay = 1000 * 60 * 60 * 24;
export const getEpochSeconds = () => Math.floor(Date.now() / 1000);
export const millisecondsToSeconds = (ms) => Math.floor(ms / 1000);
export const secondsToMilliseconds = (s) => Math.floor(s * 1000);
export const getStamp = getEpochSeconds;
export const getDeltaEpochSeconds = (timestamp) => getEpochSeconds() - timestamp;
export const isFuture = (timestamp) => getDeltaEpochSeconds(timestamp) < 0;
export const isPast = (timestamp) => getDeltaEpochSeconds(timestamp) >= 0;
// NOTE: This will return a float. Use Math.floor or Math.ceil on the return
// value to get an integer.
export function millisecondsToDays(ms) {
    return ms / millisecondsPerDay;
}
export function daysToMilliseconds(days) {
    return days * millisecondsPerDay;
}
export function minutesToMilliseconds(minutes) {
    return minutes * 60 * 1000;
}
